import { render, staticRenderFns } from "./redpacket_order.vue?vue&type=template&id=6ee2c714"
import script from "./redpacket_order.vue?vue&type=script&lang=ts"
export * from "./redpacket_order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports